export default {
  listProducts: [],
  listInventaireProducts: [],
  listInventaireProductsAverageQty: {},
  inventaireHead: {},
};
